import React from "react";

const Banner = ({ route, children=null }) => {
    return (
        <div className="banner">
            <div className="page-info">
                <h3 className="page" >{ route }</h3>
                <p className="breadcrumb" >Home / { route }</p>
            </div>
            { children }
        </div>
    )
}

export default Banner;